// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper"};